import axios, { AxiosRequestConfig } from 'axios';
import _ from 'lodash';

export interface AxiosConfig {
  baseUrl: string;
  visitId: number;
  facilityCode: string;
  token?: string;
}

let singletonConfig: AxiosConfig = {
  baseUrl: '',
  visitId: 0,
  facilityCode: '',
  token: ''
}

const notNil = _.negate(_.isNil)

export function setConfig(baseUrl: string, visitId: number, facilityCode: string, token: string | undefined): void {
  singletonConfig = {
    baseUrl,
    visitId,
    facilityCode,
    token
  };
}

export function getConfig(): AxiosConfig {
  return singletonConfig;
}

export async function baseAxiosCall<T>(config: AxiosRequestConfig, defaultValue: T | undefined = undefined): Promise<T> {
  const {data, status, statusText} = await axios.request<T>(config);
  const dataWithDefault = _.defaultTo(data, defaultValue);
  if (notNil(dataWithDefault) && status >= 200 && status < 300) {
    return dataWithDefault as T; // a bit hacky but this gets me around having to do a bunch more refactoring as part of this PR
  }
  throw new Error(`Error: Axios request ${config.method} ${singletonConfig.baseUrl}/${config.url} returned ${statusText}`)
}

export default async function axiosCall<T>(config: AxiosRequestConfig, defaultValue: T | undefined = undefined): Promise<T> {
  const axiosConfig: AxiosRequestConfig = {
    ...config,
    baseURL: singletonConfig.baseUrl,
    headers: {
      ...config.headers,
      ...(singletonConfig.token && { Authorization: `Bearer ${singletonConfig.token}` })
    }
  };
  return baseAxiosCall(axiosConfig, defaultValue);
}
